import getxpo from "../../../assets/images/xpope.png";
import { jsPDF } from "jspdf";
import { getProductCombinations } from "./ProductGeneration";
import "jspdf-autotable";
import { getInvoice } from "../../../config/LiveApi";

export const generatePDF = async (item,token) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageHeight = doc.internal.pageSize.height;

  const img = new Image();
  img.src = getxpo;

  doc.addImage(img, "PNG", 5, 5, 18, 18);

  const transactionID = item.transactionId;
  const date = new Date(item.createdAt);
  const day = date.getDate();
  const startDate = new Date(date);
  startDate.setDate(date.getDate() + 3);

  const endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);

  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  
  // Adjusted properties
  const customerName = item.requestData?.customerName;
  const phoneNumber = item.requestData?.customerMobile;
  const email = item.requestData?.customerEmail;
  const amount = item.requestData?.amount;

  const payoutData = await getInvoice(
    token,
    transactionID,
    startDate.toISOString(),
    endDate.toISOString()
  );

  const productInfo = getProductCombinations(amount);
  const productList = productInfo.products;
  const discount = productInfo.balance;

  if (!("count" in payoutData)) {
    alert("Payout not available for the selected payin!!!");
    return;
  }
  const invoice = payoutData.count;

  payoutData.name = payoutData.name === undefined ? "" : payoutData.name;
  payoutData.email = payoutData.email === undefined ? "" : payoutData.email;

  doc.setFontSize(18);
  doc.text("BILL INVOICE", 105, 10, null, null, "center");

  doc.setFont("helvetica", "bold");
  doc.setFillColor(210);
  doc.text("Exposition Techplat Pvt. Ltd.", 105, 20, null, null, "center");

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0);
  doc.text(
    "Office # 301/3, Garg Plaza, Bhera Enclaven, Sunder Vihar, Delhi, India- 110087",
    105,
    25,
    null,
    null,
    "center"
  );
  doc.text("Phone: +91 9899975358", 60, 30);
  doc.text("GSTIN: 07AAICE3377M1Z5", 110, 30);

  doc.setFontSize(12);
  doc.text("BILL TO:", 10, 60);
  doc.setFont("helvetica", "bold");
  doc.text(`${customerName} (Buyer)`, 10, 70);
  doc.setFont("helvetica", "normal");
  doc.text(`Phone: ${phoneNumber}`, 10, 75);
  doc.text(`Email: ${email}`, 10, 80);

  doc.setFontSize(11);
  doc.text(`Invoice No: XP/${day}-${month}-${year}/${invoice}`, 20, 40);
  doc.text(`Invoice Date: ${formattedDate}`, 20, 45);

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(`${payoutData.name} (Seller)`, 120, 70);
  doc.setFont("helvetica", "normal");
  doc.text(`Email: ${payoutData.email}`, 120, 75);

  doc.setFillColor(226, 76, 117);
  doc.rect(10, 90, 190, 8, "F");
  doc.setTextColor(255);
  doc.text("Sr. No.", 12, 95);
  doc.text("Items", 35, 95);
  doc.text("Quantity", 85, 95);
  doc.text("Price / Unit", 115, 95);
  doc.text("Amount", 175, 95);

  doc.setTextColor(0);

  let yPosition = 105;
  let totalCount = 0;
  let totalAmount = 0;

  Object.entries(productList).forEach(([itemName, product], index) => {
    const price = parseFloat(product.price);
    const quantity = parseInt(product.quantity, 10);
    const totalPrice = price * quantity;

    const maxItemNameWidth = 45;
    const splitItemName = doc.splitTextToSize(itemName, maxItemNameWidth);
    const itemNameHeight = splitItemName.length * 5;

    if (yPosition + itemNameHeight + 10 > pageHeight - 20) {
      doc.addPage();
      yPosition = 20;
      doc.setFillColor(7, 235, 122);
      doc.rect(10, 10, 190, 8, "F");
      doc.setTextColor(255);
      doc.text("Sr. No.", 12, 15);
      doc.text("Items", 35, 15);
      doc.text("Quantity", 85, 15);
      doc.text("Price / Unit", 115, 15);
      doc.text("Amount", 175, 15);
      doc.setTextColor(0);
    }

    doc.text(`${index + 1}`, 12, yPosition);

    splitItemName.forEach((line, lineIndex) => {
      doc.text(line, 35, yPosition + lineIndex * 5);
    });

    doc.text(`${quantity}`, 85, yPosition);
    doc.text(`Rs. ${price}`, 115, yPosition);
    doc.text(`Rs. ${totalPrice}`, 175, yPosition);

    totalCount += Number(quantity);
    totalAmount += Number(totalPrice);

    yPosition += itemNameHeight + 5;
  });

  if (yPosition + 30 > pageHeight - 20) {
    doc.addPage();
    yPosition = 20;
  }

  doc.setFillColor(226, 76, 117);
  doc.rect(10, yPosition, 190, 8, "F");
  doc.setTextColor(255);
  doc.text("Total", 35, yPosition + 5);
  doc.text(`${totalCount}`, 85, yPosition + 5);
  doc.text(`Rs. ${totalAmount}`, 175, yPosition + 5);

  yPosition += 15;

  doc.setTextColor(0);
  doc.text("Discount", 10, yPosition);
  doc.text(`Rs. ${discount}`, 175, yPosition);

  yPosition += 10;

  doc.text("Received Amount", 10, yPosition);
  doc.text(`Rs. ${amount}`, 175, yPosition);

  yPosition += 30;

  doc.text("Terms & Conditions:", 20, yPosition);
  doc.text(
    "1. Customer will pay the delivery charges, if applicable",
    20,
    yPosition + 5
  );
  doc.text(
    "2. GST liability, if any, will be borne by seller only.",
    20,
    yPosition + 10
  );
  doc.text(
    "3. All disputes are subject to Delhi Jurisdiction.",
    20,
    yPosition + 15
  );

  yPosition += 40;

  if (yPosition + 10 > pageHeight - 20) {
    doc.addPage();
    yPosition = 20;
  }

  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  doc.text(
    "*This is a computer generated invoice, no stamp or signature is required.",
    100,
    yPosition
  );

  const fileName = `Invoice_XP/${day}-${month}-${year}/${invoice}.pdf`;

  doc.save(fileName);
};

  const exportPdfHandler = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.autoTable({
      html: "#transaction-table",
    });
    doc.save("Transaction.pdf");
  };
